<template>
  <form class="attachment-filter-form" @submit.prevent="submit">
    <grid size="medium" class="uk-dropdown-grid uk-grid-divider">
      <div class="uk-width-1-2">
        <ul class="uk-nav uk-dropdown-nav">
          <li class="uk-nav-header">{{$t('headers.type')}}</li>
          <li>
            <radio-group-input v-model="form.model.type"
                               :collection="availableTypeFilters"
                               :inline="false"
                               :label="undefined"
                               :include-blank="$t('filters.undefined')" />
          </li>
        </ul>
      </div>
      <div class="uk-width-1-2">
        <ul class="uk-nav uk-dropdown-nav">
          <li class="uk-nav-header">{{$t('headers.contentType')}}</li>
          <li>
            <radio-group-input v-model="form.model.contentType"
                               :collection="availableContentTypeFilters"
                               :inline="false"
                               :label="undefined"
                               :include-blank="$t('filters.undefined')" />
          </li>
        </ul>
      </div>
    </grid>
    <grid size="medium" class="uk-dropdown-grid">
      <div class="uk-width-1-2">
        <submit-button type="primary"
                       icon="check"
                       :text="$t('actions.apply')"
                       class="uk-width-1-1" />
      </div>
      <div class="uk-width-1-2">
        <common-button icon="close"
                       :text="$t('actions.reset')"
                       @click="reset"
                       class="uk-width-1-1" />
      </div>
    </grid>
  </form>
</template>

<script>
import CommonButton from '@/components/CommonButton';
import Form from '@/mixins/LegacyForm';
import Grid from '@/components/Grid';
import RadioGroupInput from '@/components/RadioGroupInput';
import SubmitButton from '@/components/SubmitButton';

const CONTENT_TYPE_FILTERS = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/svg+xml',
  'application/pdf',
];

const TYPE_FILTERS = [
  'IMAGE',
  'VIDEO',
  'DOCUMENT',
];

export default {
  name: 'attachment-filter-form',
  mixins: [
    Form({
      type: true,
      contentType: true,
    }),
  ],
  components: {
    CommonButton,
    Grid,
    RadioGroupInput,
    SubmitButton,
  },
  computed: {
    availableTypeFilters() {
      return TYPE_FILTERS.map(filter => ({
        label: filter,
        value: filter,
      }));
    },
    availableContentTypeFilters() {
      return CONTENT_TYPE_FILTERS.map(filter => ({
        label: filter,
        value: filter,
      }));
    },
  },
  methods: {
    reset() {
      this.form.model.type = undefined;
      this.form.model.contentType = undefined;
      this.submit();
    },
  },
  i18n: {
    messages: {
      de: {
        headers: {
          type: 'Bild-Typ',
          contentType: 'MIME-Type',
        },
        filters: {
          undefined: 'Alle',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// AttachmentFilterForm.vue?5a686d2b